import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";
import microfrontendLayout from "./microfrontend-layout.html";
import MicrofrontProps from './microfront-props.js';

startSingleSpaApplications()

function startSingleSpaApplications() {
  const routes = constructRoutes(microfrontendLayout);
  const applications = constructApplications({
    routes,
    loadApp({ name }) {
      return System.import(name).then((appModule) => {
        // Extend the application mount function to pass props
        const originalMount = appModule.mount;
        appModule.mount = (props) =>
          originalMount({ ...props, ...MicrofrontProps[name] });
        return appModule;
      });
    },
  });
  const layoutEngine = constructLayoutEngine({ routes, applications });

  applications.forEach(registerApplication);
  layoutEngine.activate();
  start();
}
